import React from 'react';
import classNames from 'classnames';

/* eslint no-mixed-operators:0 */

const QUADRANTAL_PERCENTAGE_EPSILON = 0.015;

function getNearestQuadrantalPercentage(percentage) {
  // eslint-disable-next-line
  for (const quadrantalPercentage of [0.25, 0.5, 0.75]) {
    const diff = quadrantalPercentage - parseFloat(percentage.toFixed(2));
    if (Math.abs(diff) <= QUADRANTAL_PERCENTAGE_EPSILON) {
      return quadrantalPercentage;
    }
  }
  return null;
}

function roundPercentage(percentage, nearestPercentile) {
  let rounded;
  const nearestQuadrantalPercentage =
    getNearestQuadrantalPercentage(percentage);
  if (nearestQuadrantalPercentage) {
    rounded = nearestQuadrantalPercentage;
  } else {
    rounded = Math.round(percentage / nearestPercentile) * nearestPercentile;
    if (percentage > 0 && rounded === 0) {
      rounded = nearestPercentile;
    }
    if (percentage < 1 && rounded >= 1 - nearestPercentile) {
      rounded = 1 - nearestPercentile;
    }
  }
  return rounded;
}

const RadialProgress = ({
  size,
  gapWidth,
  strokeWidth,
  progress,
  nearestNth,
  className,
  fgColor,
  bgColor,
}) => {
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = Math.PI * radius * 2;

  const progressRounded = roundPercentage(progress, nearestNth / 100);
  const progressArchLength = 2 * Math.PI * radius * progressRounded;
  const progressDashOffset = circumference - circumference * progressRounded;
  const progressEndAngle = (progressArchLength * 360) / circumference;

  const sharedCircleProps = {
    r: radius,
    cx: center,
    cy: center,
    strokeWidth,
    strokeDasharray: circumference,
    fill: 'transparent',
  };

  const sharedGapProps = {
    height: strokeWidth + 2,
    width: gapWidth,
    fill: '#fff',
    x: center - gapWidth / 2,
    y: -1,
  };

  return (
    <svg
      version="1.1"
      xml="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={classNames('RadialProgress', className)}
    >
      <circle stroke={bgColor} {...sharedCircleProps} />
      <circle
        stroke={fgColor}
        transform={`rotate(270 ${center} ${center})`}
        strokeDashoffset={progressDashOffset}
        {...sharedCircleProps}
      />
      <rect {...sharedGapProps} key="start" />
      <rect
        {...sharedGapProps}
        transform={`rotate(${progressEndAngle} ${center} ${center})`}
      />
    </svg>
  );
};

RadialProgress.defaultProps = {
  strokeWidth: 4,
  gapWidth: 2,
  size: 18,
  fgColor: '#000',
  bgColor: '#d3d3d3',
  nearestNth: 10,
};

export default RadialProgress;
